import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { InformationSectionComponent } from './information-section/information-section.component';
import { NgChartsModule } from 'ng2-charts';

@NgModule({
  declarations: [InformationSectionComponent],
  imports: [
    SharedModule,
    NgChartsModule
  ],
  exports: [
    InformationSectionComponent
  ]
})
export class DashboardModule {
}
